import React from 'react'
import AdminDashboardClient from '../../components/AdminDashboardClient'
import { supabase } from "../../utils/supabase/client"

async function getAdminDashboardData() {
  const { data, error } = await supabase.functions.invoke('get-admin-dashboard')
  if (error) {
    // The error from the function is an object, not a string
    const errorMessage = error.context?.msg || error.message || "An unknown error occurred.";
    throw new Error(errorMessage);
  }
  return data || []
}

export default function AdminDashboardPage() {
  const [data, setData] = React.useState<any[]>([])
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    getAdminDashboardData()
      .then(setData)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="p-8 text-center">Loading...</div>
  if (error) return <div className="p-8 text-center text-red-500">{error}</div>

  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">Admin Dashboard</h1>
      <p className="text-lg text-muted-foreground mt-2">
        An overview of all organizations, revenue, and activity on your platform.
      </p>
      <div className="mt-8">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
          <AdminDashboardClient organizations={data} />
        </div>
      </div>
    </div>
  )
} 